import { userService } from "../services";
import config from "../config/config";
import { useSnackbar } from "../components/CommonComponents/SnackbarProvider";

export const PermissionAction = {
  fetchPermissionList,
  fetchPermissionListForAudit,
};

async function fetchPermissionList(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.permission_category}`;
    debugger;
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchPermissionListForAudit(showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.AllpermissionName}`;
    debugger;
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
